/* !
 * jQuery index v1.0.0
 * Copyright 2018, Connecty Inc.
 */

var popfindConf = popfindConf || {};
let thisUid = "8bd765d0232747f983a340e6a418a638u"; //本番用
// let thisUid = "ef33beade6fd48a886364c630db3c038u"; //検証用
popfindConf["data-sitesearch"] = {
	uid: thisUid,
	mode: "sitesearch",
	resultCountList: [10, 20, 30], //10, 20, 30で表示件数を指定
	inputId: "q,q2", //検索ボックスのID要素を指定
	additionalAttribute: [[
		"PF_ADDR:www.paris-miki.co.jp"
	]],
	pagenationType: 2,
    pagenationCount: 5,
};
// (function () {
// 	var s = document.createElement("script");
// 	s.charset = "utf-8";
// 	s.src = "//popfind.probo.biz/current/js/popfind.min.js";
// 	document.getElementsByTagName("head")[0].appendChild(s);
// })();
var poplink3 = [
	{
		uid: thisUid,
		deviceType: { desktop: 'pcia', mobile: 'spia' },//レスポンシブ用
		target: "#q"
	}
];
// #q2がある場合のみ追加
if(document.querySelector('input[type="text"][id="q2"]')) {
	poplink3.push({	
		uid: thisUid,
		deviceType: { desktop: 'pcia', mobile: 'spia' },//レスポンシブ用
		target: "#q2"
	})
}

(function(){
	var script = document.createElement('script');
	script.setAttribute('src', 'https://js.poplink.jp/9c32f31a5d144cdcae8ba50064577eb4u/poptagmanager.js?ts=' + Date.now());
	script.setAttribute('defer', true);
	document.head.appendChild(script);
})();
